import { render, staticRenderFns } from "./InvestorRelations.vue?vue&type=template&id=2232b644"
import script from "./InvestorRelations.vue?vue&type=script&lang=js"
export * from "./InvestorRelations.vue?vue&type=script&lang=js"
import style0 from "./InvestorRelations.vue?vue&type=style&index=0&id=2232b644&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports